import { type FC } from 'react';

import { CustomizationEmbedWarning } from '@/features/selectionsPanel/exportMenu/customizationEmbedWarning';
import { SelectionCopyableLinks } from '@/features/selectionsPanel/exportMenu/selectionCopyableLinks';
import { SelectionDownloadOptions } from '@/features/selectionsPanel/exportMenu/selectionDownloadOptions';
import { SelectionEmbedOptions } from '@/features/selectionsPanel/exportMenu/selectionEmbedOptions';
import { SelectionReportTypeOptions } from '@/features/selectionsPanel/exportMenu/selectionReportTypeOptions';

export const TopLevelExportMenu: FC = () => {
  return (
    <div>
      <CustomizationEmbedWarning />
      <SelectionCopyableLinks />
      <SelectionReportTypeOptions />
      <SelectionDownloadOptions />
      <SelectionEmbedOptions />
    </div>
  );
};
